import { render, staticRenderFns } from "./transfer_personal.vue?vue&type=template&id=7742a556"
import script from "./transfer_personal.vue?vue&type=script&lang=js"
export * from "./transfer_personal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports